import styled from 'styled-components';

export const MainPage = styled.div`
  display: flex;

  @media (max-width: 1080px) {
    flex-direction: column;
  }
`;
